module.exports = __webpack_public_path__ + "img/futb-thumb.b5531e2a.jpg";